<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 产品管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>产品报价</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
		
		<!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-form-item label="产品" prop="productInfo">
					<el-cascader
						:options="productOptions"
						v-model="form.productInfo"
						@change="handleProductChange" filterable clearable>
					</el-cascader>
				</el-form-item>
				<el-form-item label="报价公司" prop="channelId">
					<el-select v-model="form.channelId" placeholder="请选择报价公司" filterable @change="onChangeCompanyId">
						<el-option key="" label="请选择报价公司" value=""></el-option>
						<el-option v-for="item in channelKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="价格" prop="price">
					<el-input v-model="form.price" placeholder="价格，不输入表示有库存未报价"></el-input>
				</el-form-item>
				<el-form-item label="报价人" prop="operator">
					<el-input v-model="form.operator"></el-input>
				</el-form-item>
				<el-form-item label="货期" prop="period">
					<el-input type=textarea :rows=3 v-model="form.period"> </el-input>
				</el-form-item>
			</el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
			
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="批量报价" :visible.sync="batchVisible" width="50%">
            <el-form ref="batch" :model="batch" label-width="120px" :rules="batchRules">
				<el-form-item label="报价公司" prop="channelId">
					<el-select v-model="batch.channelId" placeholder="请选择报价公司" filterable @change="onChangeCompanyId">
						<el-option key="" label="请选择报价公司" value=""></el-option>
						<el-option v-for="item in channelKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="报价" prop="offerInfo">
					<el-input type=textarea :rows=5 v-model="batch.offerInfo"> </el-input>
				</el-form-item>
				<el-form-item label="报价人" prop="operator">
					<el-input v-model="batch.operator"></el-input>
				</el-form-item>
			</el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="batchVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveBatch" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="量价" :visible.sync="quantityVisible" width="40%">
            <el-form ref="quantity" :model="quantity" label-width="120px" :rules="quantityRules">
				<el-form-item label="产品" prop="productInfo">
					<el-cascader
						:options="productOptions"
						v-model="quantity.productInfo"
						@change="handleProductQuantityChange" filterable clearable>
					</el-cascader>
				</el-form-item>
				<el-form-item label="报价公司" prop="channelId">
					<el-select v-model="quantity.channelId" placeholder="请选择报价公司" filterable  @change="onChangeCompanyId">
						<el-option key="" label="请选择报价公司" value=""></el-option>
						<el-option v-for="item in channelKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="价格" prop="price">
					<el-input v-model="quantity.price"></el-input>
				</el-form-item>
				<el-form-item label="数量要求" prop="period">
					<el-input v-model="quantity.period"> </el-input>
				</el-form-item>
				<el-form-item label="报价人" prop="operator">
					<el-input v-model="quantity.operator"></el-input>
				</el-form-item>
			</el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="quantityVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveQuantity" v-prevent-re-click>确 定</el-button>
            </span>
			
        </el-dialog>
		
		<!-- :span-method="arraySpanMethod" -->
        <div class="container">
            <div class="handle-box">
				<el-cascader  placeholder="请选择产品"
					:options="productOptions"
					v-model="query.productInfo" filterable clearable>
				</el-cascader> &nbsp;
				<el-select v-model="query.channelId" filterable placeholder="请选择报价公司">
					<el-option key="" label="请选择报价公司" value=""></el-option>
					<el-option v-for="item in channelKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>&nbsp;
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >单个报价</el-button>
				
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAddBatch"
					v-if="controll['add-batch']"
                >批量报价</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAddQuantity"
					v-if="controll['add-quantity']"
                >单个量价</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="name" label="产品名称" width = "150">
					<template slot-scope="scope">{{scope.row.name + (scope.row.productNo?(" / " + scope.row.productNo):"")}}</template>
				</el-table-column>
                <el-table-column prop="typeSeriesRemark" label="系列" width = "200"></el-table-column>
				<el-table-column prop="channelName" label="渠道名称"></el-table-column>
				<el-table-column label="报价" align="center">
					<el-table-column prop="newestPrice" label="最新报价" width = "85"><template slot-scope="scope">{{scope.row.newestPrice?"￥" + scope.row.newestPrice:"暂无报价"}}</template></el-table-column>
					<el-table-column prop="period" label="货期、说明" width = "130"></el-table-column>
					<el-table-column prop="newestPriceTime" label="最新报价时间" width = "110"></el-table-column>
					<el-table-column prop="quantityPrice" label="量价" width = "85"><template slot-scope="scope">{{scope.row.quantityPrice?"￥" + scope.row.quantityPrice:""}}</template></el-table-column>
					<el-table-column prop="quantityNum" label="数量要求" width = "80"></el-table-column>
					<el-table-column label="历史报价范围" width = "135"><template slot-scope="scope">{{scope.row.minimumPrice?
					("￥"+scope.row.minimumPrice + " - ￥" + scope.row.highestPrice):"暂无报价"}}</template></el-table-column>
				</el-table-column>
				<el-table-column prop="updateTime" label="更新时间" width = "105"></el-table-column>
				<el-table-column label="操作" align="center" width = "100">
					<template slot-scope="scope">
						<router-link  :to="{path:'/product-offer-history',query:{productId:scope.row.productId, productName:scope.row.name, channelId:scope.row.channelId}}" v-if="controll['product-offer-history']">
						<el-button
							type="text"
							icon="el-icon-link"
							v-if="controll['product-offer-history']"
						>历史报价</el-button>
						</router-link>
					</template>
				</el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { getOfferPages, getOfferHistoryPages, offer, getAllProducts, getChannelKV, offerBatch, getChannel, offerQuantity } from '../../../api/index';
export default {
    name: 'product-offer',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			rules: {
                productInfo: [{ required: true, message: '请选择产品', trigger: 'blur' }],
                channelId: [{ required: true, message: '请选择报价公司', trigger: 'blur' }]
            },
			batchRules:{
				channelId: [{ required: true, message: '请选择报价公司', trigger: 'blur' }],
			    offerInfo: [{ required: true, message: '请输入报价信息', trigger: 'blur' }],
                operator: [{ required: true, message: '请输入报价人', trigger: 'blur' }]
			},
			currentId:0,
			offerSize:{},
			productOptions:[],
			channelKV:[],
			batchVisible:false,
			batch:{},
			quantityVisible:false,
			quantity:{},
			quantityRules:{
				channelId: [{ required: true, message: '请选择报价公司', trigger: 'blur' }],
			    offerInfo: [{ required: true, message: '请输入报价信息', trigger: 'blur' }],
				price: [{ required: true, message: '请输入报价', trigger: 'blur' }],
				period: [{ required: true, message: '请输入数量要求', trigger: 'blur' }],
                operator: [{ required: true, message: '请输入报价人', trigger: 'blur' }]
			},
			controll:{}
        };		
    },
    created() {
		this.controll = getControll("product-offer");
		this.getProducts();
		this.getChannels();
        this.getData();
    },
    methods: {	
	    //合并单元格
		arraySpanMethod({ row, column, rowIndex, columnIndex }) {
			//列属性匹配
			if (rowIndex === 0 && columnIndex == 0) {
				this.currentId = 0;
			}
			if (columnIndex < 3) {
				//若合并表指向本单元格则构建合并参数并返回
				if (row.productId != this.currentId) {
					if (columnIndex === 2) {
						this.currentId = row.productId;
					}
					return [this.offerSize[rowIndex],columnIndex];
				} else {//否则隐藏该单元格。这里必须有，否则单元格会被右移一列
					return [0, 0];
				}
			} else {
				return [1,1];
			}
		},
		//获取产品信息
		getProducts() {
			getAllProducts().then(res => {
				if (res.code == 0) {
					this.productOptions = res.data;
				} else {
					this.$message.error(`获取产品信息失败！` + res.message);
				}
			})
		},
		//获取渠道
		getChannels() {
			getChannelKV().then(res => {
				if (res.code == 0) {
					this.channelKV = res.data;
				} else {
					this.$message.error(`获取渠道信息失败！` + res.message);
				}
			});
		},
		onChangeCompanyId(value) {
			getChannel(value).then(res => {
				if (res.code == 0) {
					this.$set(this.form, "operator", res.data.contact);
					this.$set(this.batch, "operator", res.data.contact);
					this.$set(this.quantity, "operator", res.data.contact);
				} else {
					this.$message.error(`获取联系人信息失败！` + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
			this.query.productId = null;
			if (this.query.productInfo != null) {
				let productId = this.query.productInfo[2];
				if (productId != "") {
					this.query.productId = productId;
				}
			}
            getOfferPages(this.query).then(res => { 
				if (res.code == 0 ) {
				    this.tableData = [];
					for (var i = 0; i < res.data.records.length; i ++) {
						for (var j = 0; j < res.data.records[i].offer.length; j ++) {
							let data = res.data.records[i].offer[j];
							data["productId"] = res.data.records[i].id;
							data["name"] = res.data.records[i].name;
							data["productNo"] = res.data.records[i].productNo;
							data["typeSeriesRemark"] = res.data.records[i].typeSeriesRemark;
							this.tableData.push(data);
						}
						this.offerSize[res.data.records[i].id] = res.data.records[i].offer.length;
					}
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		handleProductChange(value) {
			this.form.productId = value[2];
		},
		handleProductQuantityChange(value) {
			this.quantity.productId = value[2];
		},
		//添加操作
		handleAdd() {
			this.form = {};
			this.form.productInfo = "";
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					offer(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error('保存失败！' + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		//添加操作
		handleAddBatch() {
			this.batch = {};
			this.batchVisible = true;
		},
        // 保存编辑
        saveBatch() {
			this.$refs.batch.validate(valid => {
				if (valid) {
					offerBatch(this.batch).then(res => {
						if (res.code == 0) {
							if (res.data == "") {
								this.$message.success('保存成功！');
							} else {
								alert('部分报价保存成功，记录：' + res.data + ' 保存失败！');
							}
							this.batchVisible = false;
							this.getData();
						} else {
							this.$message.error('保存失败！' + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
		saveQuantity(){
			this.$refs.quantity.validate(valid => {
				if (valid) {
					offerQuantity(this.quantity).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.quantityVisible = false;
							this.getData();
						} else {
							this.$message.error('保存失败！' + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
		handleAddQuantity(){
			this.quantity = {};
			this.quantityVisible = true;
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
